import { Component, inject, Input, OnInit } from '@angular/core';
import { PermissionService } from '../../../../../../services/permission.service';
import { Mission } from '../../../../../../models/Mission';
import { isMissionExpired } from '../../../../../../shared/utils/utils.functions';
import { CandidatStatusOnMission } from '../../../../../../shared/utils/enums';
import { EtablissementData } from '../../../../../../shared/utils/data/etablissments-data';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { CustomDialogComponent } from '../../../../../../shared/custom-dialog/custom-dialog.component';
import { MissionService } from '../../../../../../services/mission.service';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { SharedModule } from '../../../../../../shared/shared.module';
import { EstablishmentService } from '../../../../../../services/establishment.service';
import { DocuSignService } from '../../../../../../services/docu-sign.service';
import { SvgIconComponent } from 'angular-svg-icon';
import {MissionDetailsComponent} from "../../mission-details/mission-details.component";

@Component({
  selector: 'app-mission-candidate-table-actions',
  templateUrl: './mission-candidate-table-actions.component.html',
  styleUrl: './mission-candidate-table-actions.component.scss',
  imports: [
      TooltipModule,
      SharedModule,
      SvgIconComponent
    ],
    standalone: true
})
export class MissionCandidateTableActionsComponent implements OnInit {

  @Input() data: Mission;
  @Input() column: any;
  expired: boolean = false;
  loadingContract = false;
  private readonly permissionService = inject(PermissionService);

  /**
   * Annuler une candidature : « Répondre aux missions » (MISSION_VIEW) tant qu'elle n'est pas affectée,
   * « Annuler une candidature (acceptée et/ou signée) » (MISSION_CANCEL) une fois acceptée / signée. Le back reste l'autorité.
   */
  canCancelCandidacy(): boolean {
    return this.permissionService.has(
      this.data?.statusOfCandidatOnMission === CandidatStatusOnMission.CANDIDAT_APPLIED_ON_THIS_MISSION
        ? 'MISSION_VIEW' : 'MISSION_CANCEL');
  }

  constructor(private dialog: MatDialog, private route: ActivatedRoute,
    private missionService: MissionService, private establishmentService: EstablishmentService,
    private docuSign: DocuSignService) {}


  ngOnInit(): void {
    console.log("this.data====> ", this.data)
      this.expired = isMissionExpired(this.data.enddate, this.data.endtime);
  }

  get candidatStatusOnMission(): typeof CandidatStatusOnMission {
    return CandidatStatusOnMission;
  }

  sendReminder() {
    const dialogRef = this.dialog.open(CustomDialogComponent, {
      data: {
        title: this.data.statusOfCandidatOnMission === CandidatStatusOnMission.ACCEPTED ? EtablissementData.mission.signContractReminder.title : this.data.statusOfCandidatOnMission === CandidatStatusOnMission.WAITING_FOR_ESTABLISHMENT_VALIDATION ? EtablissementData.mission.validateMissionReminder.title : null,
        description: this.data.statusOfCandidatOnMission === CandidatStatusOnMission.ACCEPTED ? EtablissementData.mission.signContractReminder.description : this.data.statusOfCandidatOnMission === CandidatStatusOnMission.WAITING_FOR_ESTABLISHMENT_VALIDATION ? EtablissementData.mission.validateMissionReminder.description : null,
        primaryLabel: EtablissementData.mission.signContractReminder.primaryButton,
        secondaryLabel: EtablissementData.mission.signContractReminder.secondButton,
      },
      maxWidth: '464px',
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        const reminderRequest = {
          missionId: this.data.id,
          cibleId: this.data.statusOfCandidatOnMission === CandidatStatusOnMission.ACCEPTED ? this.route.snapshot.params['candidatId'] : this.data.statusOfCandidatOnMission === CandidatStatusOnMission.WAITING_FOR_ESTABLISHMENT_VALIDATION ? this.data.etablissementId : 0,
          type: this.data.statusOfCandidatOnMission === CandidatStatusOnMission.ACCEPTED ? "CANDIDATE" : this.data.statusOfCandidatOnMission === CandidatStatusOnMission.WAITING_FOR_ESTABLISHMENT_VALIDATION ? "ESTABLISHMENT" : "",
          statusOnMission: this.data.statusOfCandidatOnMission === CandidatStatusOnMission.ACCEPTED ? CandidatStatusOnMission.ACCEPTED : this.data.statusOfCandidatOnMission === CandidatStatusOnMission.WAITING_FOR_ESTABLISHMENT_VALIDATION ? CandidatStatusOnMission.WAITING_FOR_ESTABLISHMENT_VALIDATION : null
        }
        if (this.data.statusOfCandidatOnMission === CandidatStatusOnMission.ACCEPTED) {
          this.missionService.sendSignContractReminder(reminderRequest).subscribe({
            next: () => {
              this.dialog.closeAll();
              this.missionService.toggleRefreshMission();
            },
            error: (err) => {
            }
          });
        }
        if (this.data.statusOfCandidatOnMission === CandidatStatusOnMission.WAITING_FOR_ESTABLISHMENT_VALIDATION) {
          this.missionService.sendValidateMissionReminder(Number(this.route.snapshot.params['candidatId']), reminderRequest).subscribe((res) => {
            this.missionService.toggleRefreshMission();
          });
        }
      }
    });

  }

  generateContract() {
        this.loadingContract = true;
        this.establishmentService
          .generateContract(
            this.route.snapshot.params['candidatId'] ?? 0,
            this.data.id,
            this.data.etablissementId
          )
          .subscribe({
            next: () => {
              this.establishmentService
                .generateContractPreview(
                  this.route.snapshot.params['candidatId'] ?? 0,
                  this.data.id,
                  this.data.etablissementId
                )
                .subscribe({
                  next: (value) => {
                    this.loadingContract = false;
                    this.docuSign.openDocuSignDialog(value);
                  },
                  error: (error) => {
                    this.loadingContract = false;
                  },
    
                  // window.open(value, "_blank");
                });
            },
            error: (err) => {
              this.loadingContract = false;
            },
          });
  }

  cancelCandidacy() {
          const dialogRef = this.dialog.open(CustomDialogComponent, {
            data: {
              title: EtablissementData.mission.cancelCandidacy.title,
              description: EtablissementData.mission.cancelCandidacy.description,
              primaryLabel: EtablissementData.mission.cancelCandidacy.primaryButton,
              secondaryLabel: EtablissementData.mission.cancelCandidacy.secondButton,
              withFormInput: true,
              formInputPlaceholder: "Vous pouvez préciser la motif de l'annulation",
              formInputLabel: "Motif de l'annulation"
            },
            maxWidth: '464px',
            autoFocus: false,
          });
          dialogRef.afterClosed().subscribe((res: any) => {
            console.log(this.data.statusOfCandidatOnMission)
            if (res.confirm) {
              const motifBody = {
                motif: res.formValue && res.formValue != '' ? res.formValue : null
              }
              switch (this.data.statusOfCandidatOnMission) {
                case CandidatStatusOnMission.CANDIDAT_APPLIED_ON_THIS_MISSION : {
                  this.missionService.cancelCandidacyOnPendingMission(this.data.id, Number(this.route.snapshot.params['candidatId']), motifBody).subscribe((res) => {
                    this.missionService.toggleRefreshMission();
                  });
                  return;
                }
                case CandidatStatusOnMission.CONTRACT_PENDING_VALIDATION :
                case CandidatStatusOnMission.ACCEPTED : {
                  this.missionService.cancelCandidacyOnAcceptedMission(this.data.id, Number(this.route.snapshot.params['candidatId']), motifBody).subscribe((res) => {
                    this.missionService.toggleRefreshMission();
                  });
                  return;
                }
                case CandidatStatusOnMission.ACCEPTED_AND_SIGNED_BY_BOTH : {
                  this.missionService.cancelCandidacyOnAcceptedAndSignedMission(this.data.id, Number(this.route.snapshot.params['candidatId']), motifBody).subscribe((res) => {
                    this.missionService.toggleRefreshMission();
                  });
                  return;
                }
              }
            }
          });
  }

   openMissionDetails() {
      const dialog = this.dialog.open(MissionDetailsComponent, {
        width: '666px',
        height: '100vh',
        position: {right: '0'},
        backdropClass: 'bg-transparent',
        data: { ...this.data, hideCandidatures: this.column?.detailsOnly },
      });
      dialog.afterClosed().subscribe((value) => {
      });
    }

    getMotifRefus() {
      this.missionService.findMotifRefus(this.data.id, Number(this.route.snapshot.params['candidatId']), this.data.etablissementId).subscribe({
        next: (motif: any)=>  {
          this.dialog.closeAll();
          const dialogRef = this.dialog.open(CustomDialogComponent, {
            data: {
              title: EtablissementData.mission.motifRefus.title,
              description: motif.motifsRefus,
              primaryLabel: EtablissementData.mission.motifRefus.primaryButton,
              secondaryLabel: '',
            },
            maxWidth: '464px',
            autoFocus: false,
          });
  
        },
        error: (err) => {
        }
      })
    }
}
